import React, { useEffect, useState } from "react";
import { DashboardLayout } from "../Components";
import { NavLink, useNavigate } from "react-router-dom";
import axiosConfig from "../Service/axiosConfig";
import { MdOutlineDownload, MdOutlineEdit } from "react-icons/md";
import Select from "react-select";
import DataTable from "react-data-table-component";
import tableCustomStyles from "../Components/PopupModal/tableCustomStyles";
import { useDownloadExcel, downloadExcel } from "react-export-table-to-excel";
import { ReportsNav } from "../Components/navbar";
const BillItemList = () => {
  let today_date = new Date().toISOString().split("T")[0];
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [RowPerPage, setRowPerPage] = useState(20);
  const [UserData, SetUserData] = useState({});
  const [ExcellData, SetExcellData] = useState([]);
  const [filteredClients, setFilteredClients] = useState([]);
  const Store_id = JSON.parse(localStorage.getItem("Store"));
  const [formData, setFormData] = useState({
    // fromDate: today_date,
    fromDate: "",
    toDate: "",
    // toDate: today_date,
    // store: localStorage.getItem("Store")
    //   ? JSON.parse(localStorage.getItem("Store"))
    //   : [],
    // client: null,
    store: [],
    client: ""
  });
  const [dateType, setDateType] = useState([
    { label: "Today", value: "Today" },
    { label: "1 Week", value: "1 Week" },
    { label: "1 Month", value: "1 Month" },
  ]);
  const calculateDateRange = (selectedValue) => {
    const today = new Date();

    if (selectedValue === "Today") {
      const todayStr = today.toISOString().split("T")[0];
      return { fromDate: todayStr, toDate: todayStr };
    }

    if (selectedValue === "1 Week") {
      const oneWeekAgo = new Date(today);
      oneWeekAgo.setDate(today.getDate() - 7);
      const fromDateStr = oneWeekAgo.toISOString().split("T")[0];
      const toDateStr = today.toISOString().split("T")[0];
      return { fromDate: fromDateStr, toDate: toDateStr };
    }

    if (selectedValue === "1 Month") {
      const oneMonthAgo = new Date(today);
      oneMonthAgo.setMonth(today.getMonth() - 1);
      const fromDateStr = oneMonthAgo.toISOString().split("T")[0];
      const toDateStr = today.toISOString().split("T")[0];
      return { fromDate: fromDateStr, toDate: toDateStr };
    }

    return { fromDate: "", toDate: "" };
  };
  const [orderStatuses, setOrderStatuses] = useState([
    { label: "Cart", value: "Cart" },
    { label: "Placed", value: "Placed" },
    { label: "Accepted", value: "Accepted" },
    { label: "Ready to Ship", value: "Ready to Ship" },
    { label: "Shipped", value: "Shipped" },
    { label: "Delivered", value: "Delivered" },
    { label: "Rejected", value: "Rejected" },
  ]);
  const [selectedStatuses, setSelectedStatuses] = useState([]);
  const [selectedDateType, setSelectedDateType] = useState("");
  const [storeOptions, setStoreOptions] = useState([]);
  const [clientOptions, setClientOptions] = useState([]);
  const [Data, SetData] = useState([]);
  let navigate = useNavigate();

  const GetData = async () => {
    setLoading(true);
    let date_filter_from = "order_date_after";
    let date_filter_to = "order_date_before";
    try {
      const responce = await axiosConfig.get(
        `/accounts/orders/?orderstatus=${selectedStatuses.join(
          ","
        )}&${date_filter_from}=${formData.fromDate}&${date_filter_to}=${formData.toDate
        }&stores=${formData.store || ""}&user=${formData.client ? formData.client : ""
        }&page=${currentPage}&page_size=${RowPerPage}`
      );
      // const responce = await axiosConfig.get(
      //   `/accounts/orders/`
      // );
      SetData(responce.data.results);
      setLoading(false);
      setTotalRows(responce.data.count);
    } catch (error) {
      console.log(error);
    }
  };
  const timeConvert = (date) => {
    if (!date) return "";
    const givenDateTime = new Date(date);
    if (isNaN(givenDateTime.getTime())) return "";
    let hours = givenDateTime.getHours();
    const minutes = givenDateTime.getMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";
    hours %= 12;
    hours = hours || 12;
    const newTime = `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")} ${ampm}`;
    return newTime;
  };

  const handleSort = (column, direction) => {
    console.log(column, direction);
    axiosConfig
      .get(
        // `/accounts/orders/?orderstatus=Delivered&store=${formData.store?.id ? formData.store?.id : ""
        // }&${selectedDateType === "ordered_date"
        //   ? "order_date_after"
        //   : "expected_date_time_before"
        // }=${formData.fromDate}&${selectedDateType === "ordered_date"
        //   ? "order_date_before"
        //   : "expected_date_time_after"
        // }=${formData.toDate
        // }&page=${currentPage}&page_size=${RowPerPage}&ordering=${direction === "asc" ? column.name : `-${column.selector}`
        `/accounts/orders/?orderstatus=Delivered&store=${formData.store?.id ? formData.store?.id : ""
        }&order_date_after=${formData.fromDate}&order_date_before=${formData.toDate
        }&page=${currentPage}&page_size=${RowPerPage}&ordering=${direction === "asc" ? column.name : `-${column.selector}`
        }`
      )
      .then((res) => {
        SetData(res.data.results);
      })
      .catch((error) => {
        console.log(error);
      });
    setCurrentPage(1);
  };

  const HandlePrint = (invoice) => {
    if (invoice) {
      window.open(invoice.pdf_path);
    }
  };

  const HandleEdit = (order) => {
    navigate(`/dashboard/orders/${order.id}/modify`, {
      state: { order_data: order, client_data: order.client },
    });
  };

  function formatDateTime(dateTimeString) {
    if (!dateTimeString) return "N/A";
    const dateTime = new Date(dateTimeString);
    if (isNaN(dateTime.getTime())) return dateTimeString;

    const optionsDate = { year: "numeric", month: "short", day: "numeric" };
    const optionsTime = { hour: "numeric", minute: "numeric", hour12: true };

    const formattedDate = dateTime.toLocaleDateString("en-US", optionsDate);
    const formattedTime = dateTime.toLocaleTimeString("en-US", optionsTime);

    return `${formattedDate} - ${formattedTime}`;
  }

  const columns = [
    {
      name: "Order No",
      selector: "order_id",
      sortable: true,
      width: "120px",
      reorder: true
    },
    {
      name: "Name",
      selector: "full_name",
      cell: (row) => <div>{row?.user?.full_name || "N/A"}</div>,
      sortable: true,
      width: "120px",
      reorder: true
    },
    {
      name: "Items",
      selector: "total_quantity",
      sortable: true,
      width: "100px",
      reorder: true
    },
    // {
    //     name: 'Store',
    //     selector: 'store',
    //     cell: (row) => <div>{row.store.name}</div>,
    //     sortable: true,
    //     width: '100px'
    // },
    // {
    //     name: 'Delivery Agent',
    //     selector: 'delivery_agent',
    //     cell: (row) =>
    //         <div className="ellipsis w-120">
    //             {row.delivery_agent?.full_name}
    //         </div>,
    //     sortable: true,
    //     width: '120px'
    // },
    {
      name: "Billed Amount",
      selector: "net_amount",
      sortable: true,
      width: "100px",
      reorder: true
    },
    {
      name: "Payment Mode",
      selector: "payment_mode",
      sortable: true,
      width: "80px",
      reorder: true
    },
    {
      name: "Status",
      selector: "orderstatus",
      sortable: true,
      width: "120px",
      reorder: true
    },
    {
      name: "Remarks",
      selector: "delivered_time",
      cell: (row) =>
        row.remarks ? formatDateTime(row.remarks) : "N/A",
      sortable: true,
      width: "120px",
      reorder: true
    },
    {
      name: "Payment Reference Id",
      selector: "total_amount",
      cell: (row) => row.reference_id || "N/A",
      sortable: true,
      width: "100px",
      reorder: true
    },
    {
      name: "Store Name",
      selector: "name",
      cell: (row) => row?.store?.name || "N/A",
      sortable: true,
      width: "200px",
      reorder: true
    },
    {
      name: "Time Of Order",
      selector: "name",
      cell: (row) => {
        if (!row?.order_date) return "N/A";
        return <div>{row.order_date.split("T")?.[0]} {timeConvert(row.order_date)}</div>;
      },
      sortable: true,
      width: "200px",
      reorder: true
    },
    {
      name: "Time of Delivery",
      selector: "name",
      cell: (row) => {
        if (!row?.expected_date_time) return "N/A";
        return <div>{row.expected_date_time.split("T")?.[0]} {timeConvert(row.expected_date_time)}</div>;
      },
      sortable: true,
      width: "200px",
      reorder: true
    },
    {
      name: "Delivery Agent Name",
      selector: "name",
      cell: (row) => row?.delivery_agent?.user?.full_name || "N/A",
      sortable: true,
      width: "200px",
      reorder: true
    },
    // {
    //   name: "Invoice",
    //   cell: (row) => (
    //     <div style={{ cursor: "pointer" }} className="d-flex gap-10">
    //       <MdOutlineDownload
    //         size={15}
    //         color={"#1b7d78"}
    //         onClick={() => HandlePrint(row.invoice)}
    //       />
    //     </div>
    //   ),
    //   width: "80px",
    // },
  ];

  const handleRowsPerPageChange = (event) => {
    console.log(event.target.value);
    setCurrentPage(1);
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const fetchStore = async () => {
    const response = await axiosConfig.get(`/stores/stores/?page_size=1000`);
    setStoreOptions([
      ...response.data.results,
    ]);
  };

  const fetchClients = async () => {
    const response = await axiosConfig.get(`/accounts/users/?page_size=1000`);
    let customers = response.data.results.filter((ele) => ele.role === "Customer")
    setClientOptions([

      ...customers,
    ]);
    setFilteredClients([...customers],);
  };

  // const HandleselectChange = (selectedOptions, fieldName) => {
  //   const selectedValues = selectedOptions.map((item) => item.value);
  //   if (fieldName === "store") {
  //     if (selectedOptions.length === 0) {
  //       setFilteredClients(clientOptions);
  //     } else {
  //       let filtered_clients = clientOptions.filter((client) => {
  //         return client.store && selectedValues.includes(client.store.id);
  //       });
  //       console.log(filtered_clients, storeOptions, "filtered_clients");
  //       setFilteredClients(filtered_clients);
  //     }
  //   }

  //   setFormData((prevFormData) => ({
  //     ...prevFormData,
  //     [fieldName]: selectedValues,
  //   }));
  // };
  const HandleselectChange = (selectedOptions, fieldName) => {
    if (fieldName === "store") {
      const storeIds = selectedOptions.map((item) => item.value);

      setFormData((prev) => ({
        ...prev,
        store: storeIds,
      }));

      // Always show all users
      setFilteredClients(clientOptions);

    } else if (fieldName === "client") {
      // Handle single client selection (not array)
      setFormData((prev) => ({
        ...prev,
        client: selectedOptions ? selectedOptions.value : "", // Single value
      }));
    }
  };


  // const HandleTypeChange = (type, selectedOption) => {
  //   if (type === "dateType") {
  //     setSelectedDateType(selectedOption.value);
  //   } else if (type === "orderStatus") {
  //     console.log(selectedOption);
  //     setSelectedStatuses(selectedOption.map((item) => item.value));
  //   }
  // };
  const HandleTypeChange = (type, selectedOption) => {
    if (type === "dateType") {
      setSelectedDateType(selectedOption.value);

      // Calculate date range based on selection
      const dateRange = calculateDateRange(selectedOption.value);
      setFormData(prev => ({
        ...prev,
        fromDate: dateRange.fromDate,
        toDate: dateRange.toDate
      }));

    } else if (type === "orderStatus") {
      console.log(selectedOption);
      setSelectedStatuses(selectedOption.map((item) => item.value));
    }
  };
  const handleSubmit = () => {
    setCurrentPage(1); // remove getData if  getting error about page
    GetData();
  };

  const multiSelectStyles = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? "#c9dddc" : "white", // Change background color for selected option
      color: state.isSelected ? "#1b7d78" : "black", // Change text color for selected option
      ":hover": {
        backgroundColor: "#c9dddc", // Change background color on hover for options
      },
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: "#c9dddc", // Change background color for the multi-value container
      color: "#1b7d78", // Change text color for the multi-value container
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: "#1b7d78", // Change text color for the label within the multi-value container
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      color: "#1b7d78", // Change color for the "X" button within the multi-value container
      ":hover": {
        backgroundColor: "#1b7d78", // Change background color on hover for the "X" button
        color: "white",
      },
    }),
  };

  useEffect(() => {
    GetData();
    fetchStore();
    fetchClients();
  }, [currentPage, RowPerPage]);

  return (
    <>
      <div className="child-sidenav">
        <ReportsNav />
        <div className="flex-1 reports-parent">
          <div className="report-filters">
            <Select
              placeholder="Quick Filter"
              className="flex-1"
              options={dateType}
              value={dateType.find(
                (option) => option.value === selectedDateType
              )}
              onChange={(selectedOption) =>
                HandleTypeChange("dateType", selectedOption)
              }
              styles={multiSelectStyles}
            />
            <Select
              className="flex-1"
              options={orderStatuses}
              onChange={(selectedOption) =>
                HandleTypeChange("orderStatus", selectedOption)
              }
              styles={multiSelectStyles}
              placeholder="Order Status"
              isMulti
            />
            <div className="form-group flex-1">
              <input
                className="form-control"
                type="date"
                name="fromDate"
                value={formData.fromDate}
                onChange={handleChange}
              />
            </div>
            <div className="form-group flex-1">
              <input
                className="form-control"
                type="date"
                name="toDate"
                value={formData.toDate}
                onChange={handleChange}
              />
            </div>
          </div>
          <div className="report-filters">
            <Select
              placeholder="Store"
              className="flex-1"
              options={storeOptions.map((res) => ({
                value: res.id,
                label: res.name,
              }))}
              isMulti
              value={storeOptions
                .filter((res) => {
                  // Check if store is string or array
                  if (Array.isArray(formData.store)) {
                    return formData.store.includes(res.id);
                  } else if (formData.store) {
                    return formData.store.split(",").includes(String(res.id));
                  }
                  return false;
                })
                .map((res) => ({ value: res.id, label: res.name }))}

              onChange={(selectedOption) =>
                HandleselectChange(selectedOption, "store")
              }
              styles={multiSelectStyles}
              isDisabled={formData.store?.id ? true : false}
            />
            <Select
              placeholder="Users"
              className="flex-1"
              options={filteredClients.map((res) => ({
                value: res.id,
                label: res.full_name,
              }))}
              // Remove isMulti
              value={filteredClients
                .find((res) => res.id === formData.client ||
                  (Array.isArray(formData.client) && formData.client.includes(res.id)))
                ? {
                  value: filteredClients.find((res) => res.id === formData.client ||
                    (Array.isArray(formData.client) && formData.client.includes(res.id))).id,
                  label: filteredClients.find((res) => res.id === formData.client ||
                    (Array.isArray(formData.client) && formData.client.includes(res.id))).full_name
                }
                : null}
              onChange={(selectedOption) =>
                HandleselectChange(selectedOption, "client")
              }
              styles={multiSelectStyles}
            />
            <button
              className="btn btn-primary"
              style={{ height: "37px" }}
              onClick={handleSubmit}
            >
              Get Reports
            </button>
          </div>
          <DataTable
            columns={columns}
            data={Data}
            pagination
            paginationTotalRows={totalRows}
            paginationPerPage={RowPerPage}
            paginationDefaultPage={currentPage}
            onChangePage={(page) => { setCurrentPage(page); GetData() }} // remove getData if  getting error about page
            paginationPerPageOptions={[10, 20, 25, 30, 40, 50]}
            paginationRowsPerPageOptions={[10, 20, 25, 30, 40, 50]}
            onChangeRowsPerPage={(RowsPerPageChange) =>
              setRowPerPage(RowsPerPageChange)
            }
            onSort={handleSort}
            paginationServer
            customStyles={tableCustomStyles}
            progressPending={loading}
            progressComponent={
              <div className="loader-container">
                <img
                  src={require("../Components/FormParser/images/loader2.gif")}
                  alt="Loading..."
                />
              </div>
            }
          />
        </div>
      </div>
    </>
  );
};
export { BillItemList };
